import script from "./legoTreePolicyNode.vue?vue&type=script&lang=js"
export * from "./legoTreePolicyNode.vue?vue&type=script&lang=js"

import "./legoTreePolicyNode.vue?vue&type=style&index=0&id=a6f00e6c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6f00e6c"],['__file',"src/components/lego/extend/legoTreePolicyNode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a6f00e6c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a6f00e6c', __exports__)) {
    api.reload('a6f00e6c', __exports__)
  }
  
}


export default __exports__